import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';

// Context
import { AuthProvider } from './context/AuthContext';

// Components
import Navbar from './components/common/Navbar';
import Login from './components/auth/Login';
import ProtectedRoute from './components/auth/ProtectedRoute';
import AdminPage from './pages/AdminPage';
import StudentPage from './pages/StudentPage';
import SlotSelection from './components/student/SlotSelection';
import BookingConfirmation from './components/student/BookingConfirmation';
import ErrorPage from './pages/ErrorPage';

// Styles
import './styles/index.css';

// Component to conditionally render Navbar
const ConditionalNavbar = () => {
    const location = useLocation();
    
    // Routes where navbar should NOT be shown
    const hideNavbarRoutes = [
        '/login',
        '/student',
        '/student/select-slot',
        '/student/booking-confirmation',
        '/error'
    ];
    
    // Check if current path should hide navbar
    const shouldHideNavbar = hideNavbarRoutes.some(route => 
        location.pathname === route || location.pathname.startsWith(route)
    );
    
    // Don't render navbar on specified routes
    if (shouldHideNavbar) {
        return null;
    }
    
    return <Navbar />;
};

function AppContent() {
    return (
        <div className="App">
            <ConditionalNavbar />
            
            <Routes>
                {/* Auth Routes */}
                <Route path="/login" element={<Login />} />
                
                {/* Protected Admin Routes */}
                <Route 
                    path="/admin" 
                    element={
                        <ProtectedRoute>
                            <AdminPage />
                        </ProtectedRoute>
                    } 
                />
                
                {/* Student Routes (Public - No Navbar) */}
                <Route path="/student" element={<StudentPage />} />
                <Route path="/student/select-slot" element={<SlotSelection />} />
                <Route path="/student/booking-confirmation" element={<BookingConfirmation />} />
                
                {/* Default Routes */}
                <Route path="/" element={<Navigate to="/admin" replace />} />
                <Route path="/error" element={<ErrorPage />} />
                <Route path="*" element={<Navigate to="/error" replace />} />
            </Routes>

            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
                toastClassName="custom-toast"
                bodyClassName="custom-toast-body"
            />
        </div>
    );
}

function App() {
    return (
        <AuthProvider>
            <Router
                future={{
                    v7_startTransition: true,
                    v7_relativeSplatPath: true
                }}
            >
                <AppContent />
            </Router>
        </AuthProvider>
    );
}

export default App;
